<template>
  <ul class="flex flex-col gap-12">
    <!-- eslint-disable tailwindcss/no-custom-classname -->
    <li
      v-for="(category, index) in categories"
      :key="category.title"
      class="fade-in-category"
      :style="{
        animationDelay: `${(categories.length - index) * 80}ms`,
      }"
    >
      <!-- eslint-enable tailwindcss/no-custom-classname -->
      <div class="flex caption-bold p-8 gap-4 text-static-ai-hi">
        <DynamicIcon
          v-if="category.icon"
          class="shrink-0 text-static-ai-hi"
          :icon="category.icon as IconName"
          size="small"
        />

        <h2 :id="`ai-reco-category-title-${index}`">{{ category.title }}</h2>
      </div>

      <div
        class="flex grow flex-col justify-between overflow-auto scrollbar-none -mx-8"
      >
        <ul
          :aria-labelledby="`ai-reco-category-title-${index}`"
          class="mx-auto flex w-max items-start overflow-x-auto overflow-y-hidden scrollbar-none"
        >
          <li
            v-for="suggestion in category.prompts"
            :key="suggestion"
            class="ml-8 last:mr-8"
          >
            <Suggestion :suggestion @click="$emit('click', suggestion)" />
          </li>
        </ul>
      </div>
    </li>
  </ul>
</template>

<script lang="ts" setup>
import DynamicIcon from '@backmarket/nuxt-layer-cms/DynamicIcon.vue'
import type { IconName } from '@ds/icons/icons'

import Suggestion from './Suggestion.vue'

defineProps<{
  categories: Array<{ prompts: string[]; title: string; icon?: string }>
}>()

defineEmits<{ click: [suggestion: string] }>()
</script>

<style scoped>
@keyframes fade-in-category {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.fade-in-category {
  animation: 300ms ease-in both fade-in-category;
}
</style>
